webpackJsonp([10],{

/***/ 175:
/***/ (function(module, exports) {

module.exports = {"jugar":"Play","instrucciones":"Instructions"}

/***/ })

});


// WEBPACK FOOTER //
// static/js/10.3690f855ca3965c2c52d.js